﻿import { TOGGLE_VILKAR, ToggleVilkarAction } from './Types';

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}
